// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--Wc2S9";
export var image = "Hero-module--image--je9H6";
export var content = "Hero-module--content--t6GlX";
export var heading = "Hero-module--heading--ZYu-W";
export var text = "Hero-module--text--o+Ts4";